
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/offshore/accounting-and-auditing",
      function () {
        return require("private-next-pages/offshore/accounting-and-auditing/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/offshore/accounting-and-auditing"])
      });
    }
  